<template lang="html">
    <div class="page" id="skillsScore">
        <header class="pageHeader rounded darken">
            <fade-image class="darken" src="assets/headers/goals.png" />
        </header>

        <div class="scroller2 dark">
            <header>
                <h2>Practice drills</h2>

                <ul class="links">
                    <li>
                        <a class="cancel" @click.prevent="$router.back()" href="#">
                            <x-icon class="icon" />
                        </a>
                    </li>
                </ul>
            </header>
            <skills-list-item v-for="skill in skills" :key="skill.id" :skill="skill" />
            <p v-if="skills.length == 0">You don't have any skill scores at the moment</p>
        </div>
    </div>
</template>

<script>
import { XIcon } from "vue-feather-icons";
import FadeImage from "@/components/App/fade-image";
import SkillsListItem from "@/components/Player/Skills/Skills-list-item";
export default {
    name: "whats-in-the-bag",
    components: { FadeImage, SkillsListItem, XIcon },
    computed: {
        skills() {
            return this.$store.state.user.skills;
        },
    },
    created() {
        this.$store.dispatch("getUser");
    },
};
</script>

<style lang="scss" scoped>
#skillsScore {
    p {
        color: white;
    }
    .cancel {
        color: white;
    }
}
</style>
